<template>
  <div
    class="fts-form-footer-action"
    :class="{'form-footer-action--expand': expandFormAction}"
  >
    <div class="form-footer-action-container" ref="formFooterActionContainer">
      <fts-btn
        v-for="action in activities"
        :key="action.id"
        outline
        :color="action.color || 'primary'"
        :emoji="action.emoji"
        text-transform-init
        class="btn-activity"
        @click="$emit('execute:activity', action)"
      >
        <span class="btn-activity-label">{{action.name}}
          <fts-test-badge v-if="action.development" :stage="action.development"></fts-test-badge>
        </span>
      </fts-btn> 

      <fts-btn
        v-for="action in documents"
        :key="action.id"
        outline
        color="ternary-green"
        text-transform-init
        class="btn-activity"
        @click="$emit('execute:document', action)"
      >
        <font-awesome-icon :icon="['far', 'file-pdf']" class="fts-file-pdf" v-if="action.typeId === 'pdf'" />
        <font-awesome-icon :icon="['far', 'file-alt']" class="fts-file-excel" v-else-if="action.typeId === 'spreadsheet'" />
        <font-awesome-icon :icon="['far', 'file-code']" class="fts-file-html" v-else-if="action.typeId === 'html'" />
        <font-awesome-icon :icon="['far', 'file']" class="fts-file-default" v-else />
        <span class="btn-activity-label">{{action.name}}
          <fts-test-badge v-if="action.development" :stage="action.development"></fts-test-badge>
        </span>
      </fts-btn>

      <fts-btn
        v-for="action in customs"
        :key="action.id"
        outline
        :color="action.color || 'ternary-blue'"
        :emoji="action.emoji"
        text-transform-init
        class="btn-activity"
        @click="$emit('execute:custom', action)"
      >
        <span class="btn-activity-label">{{action.name}}</span>
      </fts-btn>

      <fts-activities-design-dropdown
        :activities="canvasActivities"
        @option:select="(x) => $emit('execute:activity', x)"
        @option:create="(x) => $emit('create:activity', x)"
        v-if="designMode"
      />
    </div>

    <fts-tippy
      :content="`${expandFormAction ? 'Less' : 'More'} actions`"
      v-if="toggleVisible || expandFormAction"
    >
      <fts-btn
        text
        icon
        color="var(--fts-text)"
        class="form-footer-action-toggle"
        @click="toggle"
      >
        <font-awesome-icon :icon="['fas', 'caret-right']" />
      </fts-btn>
    </fts-tippy>
  </div>
</template>

<script>
import FTSActivitiesDesignDropdown from '../../design/FTSActivitiesDesignDropdown';
import FTSBtn from '../FTSBtn';
import FTSTippy from '../FTSTippy';
import FTSTestBadge from '../FTSTestBadge.vue';

let resizeHandler = null;
let resizeObserver = null;

export default {
  props: {
    activities: Array,
    customs: Array,
    documents: Array,
    canvasActivities: Array,
    designMode: Boolean
  },
  components: {
    'fts-activities-design-dropdown': FTSActivitiesDesignDropdown,
    'fts-btn': FTSBtn,
    'fts-tippy': FTSTippy,
    'fts-test-badge': FTSTestBadge
  },
  data: () => ({
    toggleVisible: false,
    expandFormAction: false
  }),
  methods: {
    toggle() {
      this.$el.scrollTop = 0;
      this.expandFormAction = !this.expandFormAction;
      setTimeout(() => {
        if (this.expandFormAction) {
          this.$el.classList.add('fts-scrollbar');
        } else {
          this.$el.classList.remove('fts-scrollbar');
        }
      }, 300);
    }
  },
  mounted() {
    resizeHandler = _.debounce((entries) => {
      try {
        const entry = entries.find(x => x.target === this.$refs.formFooterActionContainer);
        this.toggleVisible = Boolean(entry.target.clientHeight > this.$el.clientHeight);
      } catch(err) {
        console.warn("ResizeHandler", err);
      }
    }, 300);
    resizeObserver = new ResizeObserver(resizeHandler);
    resizeObserver.observe(this.$refs.formFooterActionContainer);
  },
  beforeDestroy() {
    if (resizeHandler) {
      resizeHandler.cancel();
    }
    if (resizeObserver) {
      this.$refs.formFooterActionContainer && resizeObserver.unobserve(this.$refs.formFooterActionContainer);
      resizeObserver.disconnect();
    }
  }
}
</script>

<style lang="scss">
@use "./src/assets/scss/vars" as *;

.fts-form-footer-action {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  max-height: 51px;
  padding: 0.5rem;
  background-color: var(--fts-card-background);
  transition: max-height 0.3s ease-in-out;
  .form-footer-action-container {
    align-items: center;
    min-width: 0;
    @include flex-gap($gap: 0.5rem);
  }
  .form-footer-action-toggle {
    position: sticky;
    top: 0;
    cursor: pointer;
    > svg {
      transition: 0.3s ease-in-out;
    }
  }
  &.form-footer-action--expand {
    $max-height: calc(51px + 34px + 8px + 34px + 8px);
    max-height: $max-height;
    .form-footer-action-toggle {
      > svg {
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
      }
    }
  }
}
</style>